//** buying-role Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getEmailTemplate = createAsyncThunk('emailTemplateSlice/getEmailTemplate', async () => {
    try {
        let response = await axios.get('/email-template', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateById = createAsyncThunk('emailTemplateSlice/getEmailTemplateById', async (id) => {
    try {
        let response = await axios.get('/email-template/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateByCategory = createAsyncThunk('emailTemplateSlice/getEmailTemplateByCategory', async (id) => {
    try {
        let response = await axios.get(`/email-template?categoryId=${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateOption = createAsyncThunk('emailTemplateSlice/getEmailTemplateOption', async () => {
    try {
        let response = await axios.get('/email-template/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailTemplateCategoryOption = createAsyncThunk('emailTemplateSlice/getEmailTemplateCategoryOption', async () => {
    try {
        let response = await axios.get('/email-template-category/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createEmailTemplate = createAsyncThunk('emailTemplateSlice/createEmailTemplate', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/email-template', data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Email Template Created successfully.');
        // dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const updateEmailTemplate = createAsyncThunk('emailTemplateSlice/updateEmailTemplate', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/email-template/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Email Template updated successfully.');
        await dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const updateEmailTemplateStatus = createAsyncThunk('emailTemplateSlice/updateEmailTemplateStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/email-template/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully !');
        dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});
export const deleteEmailTemplate = createAsyncThunk('emailTemplateSlice/deleteEmailTemplate', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/email-template/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Email Template deleted successfully.');
        await dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const createEmailCategory = createAsyncThunk('emailTemplateSlice/createEmailCategory', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/email-template-category', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Email Template Category added successfully.');
        dispatch(getEmailTemplate());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const updateEmailCategory = createAsyncThunk('emailTemplateSlice/createEmailCategory', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/email-template-category/' + data.id, data.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Email Template Category update successfully.');
        dispatch(getEmailTemplateCategoryOption());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});
export const deleteEmailCategory = createAsyncThunk('emailTemplateSlice/deleteEmailCategory', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/email-template-category/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Email Template Category deleted successfully.');
        await dispatch(getEmailTemplateCategoryOption());

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');

        return Promise.reject(err);
    }
});

export const emailTemplateSlice = createSlice({
    name: 'emailTemplateSlice',
    initialState: {
        data: [],
        option: [],
        categoryOption: [],
        selectedData: {},
        selectedCategory: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEmailTemplate.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateCategoryOption.fulfilled, (state, action) => {
            state.categoryOption = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateById.fulfilled, (state, action) => {
            state.selectedData = action.payload;
            return;
        });
        builder.addCase(getEmailTemplateByCategory.fulfilled, (state, action) => {
            state.selectedCategory = action.payload;
            return;
        });
    }
});

export default emailTemplateSlice.reducer;
